"use client"
import Script from "next/script";
import { useEffect, useRef } from "react";
import EmbedConsentPlaceholder from "src/components/richtext/EmbedConsentPlaceholder";
import useIsConsentReady from "src/lib/client/useIsConsentReady";
import styles from "./WufooForm.module.css";

//#region [Props]
type WufooFormProps = {
    formUrl: string;
    className?: string;
};
//#endregion

function initForm(formUrl: string): boolean {
    let stopPolling = false;
    let formId: string | null = null;
    const match = /^https:\/\/filmweb\.wufoo\.com\/forms\/(.*?)\/?$/.exec(formUrl);
    if (match && match.length === 2) {
        formId = match[1];
    }
    if (formId) {
        const options = { 'userName': 'filmweb', 'formHash': formId, 'autoResize': true, 'height': '380', 'async': true, 'host': 'wufoo.com', 'header': 'show', 'ssl': true };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((window as any).WufooForm) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const form = new (window as any).WufooForm();
            if (form) {
                form.initialize(options);
                form.display();
                stopPolling = true;
                console.debug("Stop polling set to true");
            } else {
                console.error("No form for " + formId);
            }
        } else {
            console.error("No WufooForm");
        }
    }
    return stopPolling;
}

//#region [Component]
export default function WufooForm({ formUrl, className }: WufooFormProps) {
    const {isConsentReady} = useIsConsentReady();

    let formId = "";
    const match = /^https:\/\/filmweb\.wufoo\.com\/forms\/(.*?)\/?$/.exec(formUrl);
    if (match && match.length === 2) {
        formId = match[1];
    }

    const intervalHandle = useRef<null | number>(null);

    useEffect(() => {
        if (formUrl && isConsentReady) {

            if (intervalHandle.current === null) {
                let stopPolling = false;
                intervalHandle.current = window?.setInterval(() => {
                    stopPolling = initForm(formUrl);
                    if (stopPolling) {
                        console.debug("Stopping polling");
                        if (intervalHandle?.current) {
                            window?.clearInterval(intervalHandle.current!);
                            intervalHandle.current = null;
                        }
                    }

                }, 500) ?? null;

                return () => {
                    if (intervalHandle.current !== null) {
                        console.debug("Cancelling interval");
                        window?.clearInterval(intervalHandle.current);
                        intervalHandle.current = null;
                    }
                }
            }
        }
    }, [formUrl, isConsentReady]);

    return (
        <div className={className}>
            {!isConsentReady && <EmbedConsentPlaceholder/>}
            {isConsentReady && <>
                <Script id="wufooForm" src="https://secure.wufoo.com/scripts/embed/form.js" />
                <div id={`wufoo-${formId}`}>
                    <p>Laster skjema.....</p>
                    <p>Vises ikke skjemaet? Prøv å laste siden på nytt.</p>
                    <p><a className={styles.SFallbackLink} href={`https://filmweb.wufoo.com/forms/${formId}`} target="_blank">Du kan også fylle ut skjemaet her</a></p>
                </div>
                <div>
                    Vises ikke skjemaet? <a className={styles.SFallbackLink} href={`https://filmweb.wufoo.com/forms/${formId}`} target="_blank">Fyll ut her.</a>
                </div>
            </>}
        </div>
    );;
}
//#endregion
